import { render, staticRenderFns } from "./activityPropDetails.vue?vue&type=template&id=77ac1c40&scoped=true&"
import script from "./activityPropDetails.vue?vue&type=script&lang=js&"
export * from "./activityPropDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ac1c40",
  null
  
)

export default component.exports